
export const typesWithFixedPrice = [
  'FP',
  'FPI',
  'OH',
  'OHI',
  'CX',
  'CXI',
  'MX',
  'MXI',
  'UC',
  'UCI',
  'UP',
  'UPI',
  'MF',
  'RU',
  'RF',
  'OP',
  'FA',
  'FI',
  'FH',
  'FM',
  'VS',
  'DR',
  'EI',
  'QS',
];

export const originatorTagPrefix = [
  'MP_',
  'SME_',
];

export const partnerTypesToSearch = [
  'YX',
  'YR',
  'YA',
  'ZA',
  'VE',
];

export const ticketCategories = {
  general: 'general',
};

export const extraSalesEmployeeTypes = ['ZX', 'ZY', 'ZZ'];

export const mainPartnerTypes = [
  { type: 'AG', sort: 1 },
  { type: 'RE', icon: 'coins', sort: 2, maxEditState: 16 },
  { type: 'ZI', icon: 'map-marker', sort: 3 },
  { type: 'WE', icon: 'ship', sort: 4 },
];
export const partnerTypesWithContacts = ['CP', 'AP', 'VE', 'ZX', 'ZY', 'ZZ', 'ZA', 'ZW'];

export const additionalPartnerTypes = [
  { type: 'RG', sort: 1, maxEditState: 16 },
  { type: 'AP', sort: 2 },
  { type: 'VE', sort: 3 },
  { type: 'ZW', sort: 4 },
  { type: 'ZX', sort: 5 },
  { type: 'ZY', sort: 6 },
  { type: 'ZZ', sort: 7 },
  { type: 'ZA', sort: 8 },
  { type: 'YS', sort: 9 },
];

export const partnerTypes = {
  SHIPTO: 'WE',
  DELIVERYATPARTY: 'YX',
  INSTALLEDAT: 'ZI',
  CONTACTPERSON: 'AP',
  EMPLOYEE: 'VE',
};

export const orderStatus = {
  unknown: 0,
  draft: 1,
  created: 2,
  released: 4,
  directAssignment: 8,
  planned: 16,
  plannedTentative: 20,
  plannedConfirmed: 24,
  partiallyExecuted: 32,
  executed: 64,
  adminClosed: 128,
  closed: 265,
};

export const ticketStatus = {
  new: 1,
  inProgress: 2,
  closed: 3,
  resolved: 4,
  cancelled: 5,
};

export const ticketActionStatus = {
  0: 'Requested',
  1: 'Draft',
  2: 'Created',
  4: 'Released',
  8: 'DirectAssignment',
  16: 'Planned',
  20: 'PlannedTentative',
  24: 'PlannedConfirmed',
  32: 'PartiallyExecuted',
  64: 'Executed',
  128: 'AdminClosed',
  265: 'Closed',
  512: 'AutoClosed',
};

export const typeOfPartList = {
  xmlView: 'xmlView',
};

export const severityColorCodes = {
  informational: 3,
  moderate: 2,
  high: 1,
};

export const publishSteps = {
  unknown: { title: '', status: 0, hidden: true },
  sending: { title: 'TITLE_SENDING', status: 1 },
  validation: { title: 'TITLE_VALIDATION', status: 2 },
  confirmation: { title: 'TITLE_CONFIRMATION', status: 3 },
  receiving: { title: 'TITLE_RECEIVING', status: 4 },
  done: { title: '', status: 5, hidden: true },
  copsValidationError: { title: '', status: 6, hidden: true, name: 'FailedCopsValidation' },
  draftValidationError: { title: '', status: 7, hidden: true, name: 'FailedDraftValidation' },
  waitCycle: { title: '', status: 8, hidden: true, name: 'WaitCycle' },
};

export const validationTypes = {
  General: 1,
  Xml: 2,
  TaskList: 3,
  GtsBlock: 4,
  External: 5,
  ConfirmationWarning: 6,
};

export const publishStepsByStatus = {
  1: { title: 'TITLE_SENDING' },
  2: { title: 'TITLE_VALIDATION' },
  3: { title: 'TITLE_CONFIRMATION' },
  4: { title: 'TITLE_RECEIVING' },
};

export const errorActions = {
  delete: { actionTitle: 'DELETE', type: 0 },
  update: { actionTitle: 'UPDATE', type: 1 },
  reset: { actionTitle: 'RESET', type: 2 },
  resetToDraft: { actionTitle: 'RESET_TO_DRAFT', type: 3 },
};

export const messageCenterStatusses = [
  { title: 'UNKNOWN', status: 0, icon: 'question-circle', color: 'black' },
  { title: 'SENT_TO_PI', status: 1, icon: 'spinner', color: '#0098cc' },
  { title: 'AWAITING_VALIDATION', status: 2, icon: 'spinner', color: '#0098cc' },
  { title: 'AWAITING_CONFIRMATION', status: 3, icon: 'spinner', color: '#0098cc' },
  { title: 'AWAITING_DELTA', status: 4, icon: 'spinner', color: '#0098cc' },
  { title: 'SUCCESS', status: 5, icon: 'check-circle', color: '#00a854' },
  { title: 'FAILED', status: 6, icon: 'exclamation-circle', color: '#c8102e' },
  { title: 'FAILED_SENT_TO_PI', status: 7, icon: 'exclamation-circle', color: '#c8102e' },
  { title: 'FAILED_VALIDATION', status: 8, icon: 'exclamation-circle', color: '#c8102e' },
  { title: 'FAILED_CONFIRMATION', status: 9, icon: 'exclamation-circle', color: '#c8102e' },
  { title: 'FAILED_DELTA', status: 10, icon: 'exclamation-circle', color: '#c8102e' },
  { title: 'SENT_TO_PI', status: 11, icon: 'spinner', color: '#0098cc' },
  { title: 'FAILED_CONFIRMATION', status: 12, icon: 'exclamation-triangle', color: '#ff9600' },
];

export const indicators = {
  costToProject: 'PC',
  costToCostcenter: 'CC',
  doCharge: 'CH',
  productWarrantyPC: 'PG',
  productWarrantyCC: 'GL',
  asset: 'AT',
};

export const allCreateOrderFields = {
  serviceType: {
    name: 'serviceType',
    label: 'SERVICETYPE_LABEL',
    placeholder: 'SERVICETYPE_PLACEHOLDER',
  },
  visitType: {
    name: 'visitType',
    label: 'VISITTYPE_LABEL',
    placeholder: 'VISITTYPE_PLACEHOLDER',
  },
  paidBy: {
    name: 'paidBy',
    label: 'PAIDBY_LABEL',
    placeholder: 'PAIDBY_PLACEHOLDER',
  },
  paymentType: {
    name: 'paymentType',
    label: 'PAYMENTTYPE_LABEL',
    placeholder: 'PAYMENTTYPE_PLACEHOLDER',
  },
  businessIndicator: {
    name: 'businessIndicator',
    label: 'BUSINESS_INDICATOR_LABEL',
    placeholder: 'BUSINESS_INDICATOR_PLACEHOLDER',
  },
  businessSubType: {
    name: 'businessSubType',
    label: 'BUSINESSSUBTYPE_LABEL',
    placeholder: 'BUSINESSSUBTYPE_PLACEHOLDER',
  },
  CU: {
    name: 'contractNumber',
    label: 'CONTRACT_LABEL',
    placeholder: 'CONTRACT_PLACEHOLDER',
  },
  PC: {
    name: 'projectNumber',
    label: 'PROJECT_LABEL',
    placeholder: 'PROJECT_PLACEHOLDER',
  },
  PW: {
    name: 'projectNumber',
    label: 'PROJECT_LABEL',
    placeholder: 'PROJECT_PLACEHOLDER',
  },
  CC: {
    name: 'costCenter',
    label: 'COSTCENTER_LABEL',
    placeholder: 'COSTCENTER_PLACEHOLDER',
  },
  AT: {
    name: 'assetNumber',
    label: 'ASSET_LABEL',
    placeholder: 'ASSET_PLACEHOLDER',
  },
  description: {
    name: 'description',
    label: 'DESCRIPTION_LABEL',
    placeholder: 'DESCRIPTION_PLACEHOLDER',
    isInput: true,
  },
};

export const severities = {
  INACTIVE: 0,
  ERROR: 1,
  WARNING: 2,
  INFO: 3,
  OK: 4,
};

export const errorTypes = {
  multiLine: 'MultiLineError',
  duplication: 'DuplicationError',
};

export const tagTypes = {
  orderStatus: 'orderStatus',
  orderType: 'orderType',
};

export const referenceTypes = {
  customer: 'customer',
  installedAt: 'installedat',
  functionallocation: 'functionallocation',
  equipment: 'equipment',
  order: 'order',
  notification: 'notification',
};

export const referenceTypesMapping = {
  customer: 'Customer',
  installedat: 'Installed-at',
  equipment: 'Equipment',
  order: 'Order',
  technician: 'Technician',
};

export const ticketSnoozeOptions = [
  {
    labelKey: 'ONE_DAY',
    value: 'days_1',
    type: 'd',
    amount: 1,
    isDefault: false,
  },
  {
    labelKey: 'THREE_DAYS',
    value: 'days_3',
    type: 'd',
    amount: 3,
    isDefault: false,
  },
  {
    labelKey: 'ONE_WEEK',
    value: 'weeks_1',
    type: 'w',
    amount: 1,
    isDefault: true,
  },
  {
    labelKey: 'TWO_WEEKS',
    value: 'weeks_2',
    type: 'w',
    amount: 2,
    isDefault: false,
  },
  {
    labelKey: 'THREE_WEEKS',
    value: 'weeks_3',
    type: 'w',
    amount: 3,
    isDefault: false,
  },
  {
    labelKey: 'ONE_MONTH',
    value: 'months_1',
    type: 'M',
    amount: 1,
    isDefault: false,
  },
  {
    labelKey: 'TWO_MONTHS',
    value: 'months_2',
    type: 'M',
    amount: 2,
    isDefault: false,
  },
  {
    labelKey: 'THREE_MONTHS',
    value: 'months_3',
    type: 'M',
    amount: 3,
    isDefault: false,
  },
  {
    labelKey: 'UNTIL_DATE',
    value: 'pick',
    isDefault: false,
  },
];


export const alertSeverities = {
  1: {
    icon: 'exclamation-circle',
    text: 'action',
    colorStatus: '#C93C3C',
    priority: 1,
  },
  2: {
    icon: 'exclamation-triangle',
    text: 'warning',
    colorStatus: '#F5A623',
    priority: 2,
  },
  3: {
    icon: 'info-circle',
    text: 'info',
    colorStatus: '#3C85C9',
    priority: 3,
  },
  4: {
    icon: 'check-circle',
    text: 'ok',
    colorStatus: '#6BC93C',
    priority: 4,
  },
};

export const sortTypes = {
  ascending: 'asc',
  descending: 'desc',
  manual: 'man',
};

export const fseRowSortTypes = {
  auto: 'auto',
  manual: 'man',
};

export const enableFSEHide = false;

export const worklistDefaultSortColumn = 'TimelineDate';
export const usersDefaultSortColumn = 'DisplayName';
export const ganttDefaultSortColumn = 'Description';
export const ticketObjectFilterId = 'object';
export const equipmentStatusFilterId = 'equipmentStatus';
export const functionalLocationStatusFilterId = 'functionalLocationStatus';

export const dropdownWithOperatorFilterIds = [
  equipmentStatusFilterId,
  functionalLocationStatusFilterId,
];

export const additionalTabTypes = {
  rows: 'rows',
  columns: 'columns',
  filters: 'filters',
};

export const searchOperators = {
  contains: {
    id: 'contains',
    shortHand: '({value})',
  },
  startsWith: {
    id: 'startsWith',
    shortHand: '{value}*',
  },
  endsWith: {
    id: 'endsWith',
    shortHand: '*{value}',
  },
  exact: {
    id: 'exact',
    shortHand: '“{value}”',
  },
  matchAny: {
    id: 'matchAny',
    shortHand: '*{value}*',
  },
  matchAll: {
    id: 'matchAll',
    shortHand: '[{value}]',
  },
};

export const urlSigns = {
  groupingStart: '[',
  groupingEnd: ']',
  filterSeparator: '|~|',
  valueSeparator: ';',
  keyValueSeparator: '||',
  sortIndexSeparator: ';',
};

// Check if the value is a valid float with only one digit after the decimal point
// and before the decimal point <= 999999999
export const miscellaniousCostRegex = /^(\d{1,9})(\.\d{1})?$/;

// eslint-disable-next-line max-len
export const worklistDefaultSortParam = `${worklistDefaultSortColumn}${urlSigns.keyValueSeparator}true${urlSigns.sortIndexSeparator}0`;
export const fseManualSortColumn = 'description';
// eslint-disable-next-line max-len
export const fseManualSort = `${fseManualSortColumn}${urlSigns.keyValueSeparator}${sortTypes.manual}${urlSigns.sortIndexSeparator}0`;
// eslint-disable-next-line max-len
export const fseDefaultAutoSort = `${fseManualSortColumn}${urlSigns.keyValueSeparator}${sortTypes.ascending}${urlSigns.sortIndexSeparator}0`;

export const absenceStatusses = {
  progress: 'inProgress',
  error: 'error',
};

export const absenceUnits = {
  hours: 'hours',
  days: 'days',
};

// eslint-disable-next-line
export const ticketWorklistDefaultFilters = `status${urlSigns.keyValueSeparator}1${urlSigns.valueSeparator}2`;
export const ticketWorklistId = 'ticket';
export const notificationWorklistId = 'notification';
export const planningBoardWorklistId = 'serviceplanning';
export const defaultWorklistId = 'order';

export const defaultView = {
  templateName: 'None (select view...)',
  isNone: true,
  isExpanded: false,
};

export const defaultGanttView = {
  templateName: 'None (select view...)',
  isNone: true,
  viewRange: 'workweek',
  sorting: [{
    sortColumn: ganttDefaultSortColumn,
    sortIndex: 0,
    sortDirection: sortTypes.ascending,
  }],
  isExpanded: false,
};

export const myUnpublishedItemsViewId = 'MyUnpublishedPlanningItems';

export const blockTypes = {
  planning: 'field_service',
  absence: 'absence',
  reservation: 'reservation',
  workingHours: 'work_hours',
  holiday: 'holiday',
};

export const viewTypes = {
  user: 'user',
  system: 'system',
  campaign: 'campaign',
};

// eslint-disable-next-line
export const defaultTicketFilters = `status${urlSigns.keyValueSeparator}${urlSigns.groupingStart}1${urlSigns.valueSeparator}2${urlSigns.groupingEnd}`;

export const viewModes = {
  TOP: 'top',
  BOTTOM: 'bottom',
  TOPBOTTOM: 'topBottom',
  FULLSCREEN: 'fullscreen',
};

export const replacementValueType = {
  icon: 'icon',
  tag: 'tag',
  date: 'date',
};

export const focusCampaignPrefix = 'focusCampaign';
export const focusCampaignKeySeparator = '_';

export const homeLayout = {
  lg: [
    {
      i: 'announcements',
      x: 6,
      y: 0,
      w: 15,
      h: 8,
      isDraggable: true,
      isResizable: true,
      minW: 7,
      minH: 7,
    },
    {
      i: 'contextualInfo',
      x: 21,
      y: 0,
      w: 3,
      h: 4,
      isDraggable: false,
      isResizable: false,
      minW: 3,
      minH: 4,
      static: true,
    },
    {
      i: focusCampaignPrefix,
      x: 0,
      y: 6,
      w: 8,
      h: 10,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 6,
    },
  ],
  md: [
    {
      i: 'announcements',
      x: 6,
      y: 0,
      w: 6,
      h: 8,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 7,
    },
    {
      i: 'contextualInfo',
      x: 19,
      y: 0,
      w: 3,
      h: 4,
      isDraggable: false,
      isResizable: false,
      minW: 3,
      minH: 4,
      static: true,
    },
    {
      i: focusCampaignPrefix,
      x: 0,
      y: 6,
      w: 8,
      h: 10,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 6,
    },
  ],
  sm: [
    {
      i: 'announcements',
      x: 0,
      y: 0,
      w: 6,
      h: 6,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 6,
    },
    {
      i: 'contextualInfo',
      x: 19,
      y: 0,
      w: 3,
      h: 4,
      isDraggable: false,
      isResizable: false,
      minW: 3,
      minH: 4,
      static: true,
    },
    {
      i: focusCampaignPrefix,
      x: 0,
      y: 6,
      w: 8,
      h: 10,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 6,
    },
  ],
  xs: [
    {
      i: 'announcements',
      x: 0,
      y: 0,
      w: 4,
      h: 6,
      isDraggable: true,
      isResizable: true,
      minW: 4,
      minH: 6,
    },
    {
      i: 'contextualInfo',
      x: 19,
      y: 0,
      w: 3,
      h: 4,
      isDraggable: false,
      isResizable: false,
      minW: 3,
      minH: 4,
      static: true,
    },
    {
      i: focusCampaignPrefix,
      x: 0,
      y: 6,
      w: 8,
      h: 10,
      isDraggable: true,
      isResizable: true,
      minW: 6,
      minH: 6,
    },
  ],
};

export const leftParenthesisAlternative = '|[|';
export const rightParenthesisAlternative = '|]|';
export const dotAlternative = '|^|';

export const slashAlternative = '%2F';

export const newSearchTypes = [
  'order',
  'equipment',
  'installedat',
  'customer',
  'notification',
  'functionallocation',
];

export const powerBiHomeUrl = 'https://app.powerbi.com/';

export const powerBiConfigScopes = ['https://analysis.windows.net/powerbi/api/Report.Read.All'];

export const powerBi = 'powerbi';

export const redirectUri = {
  LCL: 'http://localhost:3010/',
  DEV: 'https://dev.ctscops.com/',
  QAS: 'https://qas.ctscops.com/',
  PRD: 'https://www.ctscops.com/',
};

export const worklistFilterIds = {
  followedSince: 'followupsince',
};

export const smartActionTypes = {
  customerDown: 'customerdown',
};

export const defaultFilterValues = {
  me: '@me',
  notMe: 'not[@me]',
};

export const technichianSkillsSortOptions = {
  level: {
    option: 'level',
    sorting: (a, b) => {
      if (a.level < b.level) {
        return 1;
      } else if (a.level > b.level) {
        return -1;
      }
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      }
      return 0;
    },
  },
  skill: {
    option: 'skill',
    sorting: (a, b) => {
      if (a.name < b.name) {
        return -1;
      } else if (a.name > b.name) {
        return 1;
      }
      if (a.level < b.level) {
        return 1;
      } else if (a.level > b.level) {
        return -1;
      }
      return 0;
    },
  },
};

export const announcementDateFormats = {
  date: 'DD/MM/YYYY',
  hour: 'HH',
  minute: 'mm',
  fullDate: 'DD/MM/YYYY HH mm',
};

export const announcementPublishOptions = {
  draft: 'daft',
  immediateInfinite: 'immediate-infinte',
  specific: 'specific',
};

export const announcementMaxStartEndTimeDiff = 15; // minutes

export const announcementCategoryColors = {
  standalone: 'purple',
  planned: 'gold',
  news: 'blue',
  issue: 'lime',
  resolved: 'green',
};

export const announcementsToShowOnFeed = 3;

export const standaloneTabKeys = {
  before: 'before',
  during: 'during',
  after: 'after',
};

export const announcementBannerHeight = 25; // px

export const mapMarkerSizeConfig = {
  default: {
    faSize: '3x',
    iconSize: [45, 36],
    iconAnchor: [22.5, 36],
    popupOffset: [0, -18],
  },
  small: {
    faSize: '2x',
    iconSize: [30, 24],
    iconAnchor: [15, 24],
    popupOffset: [0, -12],
  },
};

export const mapProviderConfigs = {
  openstreet: {
    url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
  },
  azure: {
    // eslint-disable-next-line max-len
    url: 'https://atlas.microsoft.com/map/tile?api-version={apiVersion}&tilesetId={layerId}&x={x}&y={y}&zoom={z}&language={language}&subscription-key={subscriptionKey}',
    apiVersion: '2.0',
    layers: {
      road: 'microsoft.base.road',
      satellite: 'microsoft.imagery',
    },
  },
};

export const campaignActions = [
  {
    id: 'draftOrderBackground',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: false,
  },
  {
    id: 'createOrderBackground',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: false,
  },
  {
    id: 'releaseOrderBackground',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: false,
  },
  {
    id: 'cancelOrderAction',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: true,
  },
  {
    id: 'planOrderTentativeBackground',
    needsTime: true,
    needsWorkcenter: true,
    skipDialog: false,
  },
  {
    id: 'planOrderConfirmedBackground',
    needsTime: true,
    needsWorkcenter: true,
    skipDialog: false,
  },
  {
    id: 'planOrderBackground',
    needsTime: true,
    needsWorkcenter: true,
    skipDialog: false,
  },
  {
    id: 'updateOrderBackground',
    needsTime: true,
    needsWorkcenter: true,
    skipDialog: false,
  },
  {
    id: 'createDraftOrder',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: false,
  },
  {
    id: 'deleteDraftAction',
    needsTime: false,
    needsWorkcenter: false,
    skipDialog: true,
  },
];

export const multipleProcessQuickActions = {
  processingOrders: 'processingOrders',
  publishToSap: 'publishToSap',
};

export const connectionStates = {
  Error: 'Error',
  Connected: 'Connected',
  Closed: 'Closed',
  Loading: 'Loading',
};

export const copsAuthenticatorConstants = {
  V2: 'V2.0',
  CONFIG: 'config',
  TOKEN: 'token',
  LOGIN_HINT: 'login_hint',
  ACCOUNT_USERNAME: 'account_username',
  PATHNAME: 'pathname',
  ACCESS_TOKEN: 'accessToken',
  AUTH_TYPE: 'authenticationType',
};

export default {
  typesWithFixedPrice,
  extraSalesEmployeeTypes,
  mainPartnerTypes,
  partnerTypes,
  publishSteps,
  typeOfPartList,
  severityColorCodes,
  messageCenterStatusses,
  indicators,
  worklistDefaultSortColumn,
  severities,
  urlSigns,
  miscellaniousCostRegex,
  defaultView,
  myUnpublishedItemsViewId,
  defaultTicketFilters,
  ticketActionStatus,
  usersDefaultSortColumn,
  viewModes,
  alertSeverities,
  tagTypes,
  referenceTypes,
  blockTypes,
  absenceStatusses,
  absenceUnits,
  leftParenthesisAlternative,
  rightParenthesisAlternative,
  dotAlternative,
  worklistFilterIds,
  smartActionTypes,
  worklistDefaultSortParam,
  defaultFilterValues,
  technichianSkillsSortOptions,
  announcementCategoryColors,
  announcementDateFormats,
  announcementPublishOptions,
  announcementMaxStartEndTimeDiff,
  announcementsToShowOnFeed,
  standaloneTabKeys,
  announcementBannerHeight,
  mapMarkerSizeConfig,
  mapProviderConfigs,
  campaignActions,
  focusCampaignPrefix,
  connectionStates,
  copsAuthenticatorConstants,
};
